import type {
  SchemaCmsPublishResults,
  SchemaVideoRegionShow,
  SchemaTopicShow,
  SchemaDomainShow,
  SchemaStationInfoResult,
  SchemaMemberAnnounceShow,
} from 'api'
import { NOTICE_POPUP_ID, IDCARD_POPUP_ID } from 'constant/common'
import { AdInfoMap } from 'redux/slice/app'

type Station = SchemaStationInfoResult & { enable_share?: boolean }

export const selectApp = (state: any) => state.app
export const selectHero = (state: any) => state.app.hero
export const selectAppName = (state: any) => state.app.name
export const selectCurrentSplashAd = (state: any) => state.app.currentSplashAd
export const selectIsReadyToShowSplashAd = (state: any) => state.app.isReadyToShowSplashAd
export const selectIsReadyToEnter = (state: any) => state.app.isReadyToEnter
export const selectIsViewedAdvertisement = (state: any) => state.app.isViewedAdvertisement
export const selectNavigationContent = (state: any): SchemaCmsPublishResults => state.app.navigationContent
export const selectTagList = (state: any) => state.app.tagList
export const selectProducerList = (state: any) => state.app.producerList
export const selectRegionList = (state: any, a?: any): SchemaVideoRegionShow[] => state.app.regionList
export const selectTopicList = (state: any, a?: any): SchemaTopicShow[] => state.app.topicList
export const selectFullOrigins = (state: any): SchemaDomainShow => state.app.fullOrigins
export const selectPreviewOrigin = (state: any) => state.app.previewOrigin
export const selectOfficialOrigin = (state: any) => state.app.officialOrigin
export const selectOfficialOriginList = (state: any) => state.app.officialOriginList
export const selectPictureOrigin = (state: any) => state.app.pictureOrigin
export const selectComicOrigin = (state: any) => state.app.comicOrigin
export const selectAdInfo = (state: any, a?: any): AdInfoMap => state.app.adInfo
export const selectAnnouncementList = (state: any, a?: any) => state.app.announcementList
export const selectIsSkippedAnnouncement = (state: any, a?: any) => state.app.isSkippedAnnouncement
export const selectStation = (state: any, a?: any): Station => state.app.station
export const selectRouteDetectMessage = (state: any, a?: any) => state.app.routeDetectMessage
export const selectIsShowingLaunchSplash = (state: any, a?: any): boolean => state.app.isShowingLaunchSplash
export const selectIsShowingMaintenancePage = (state: any) => state.app.isShowingMaintenancePage
export const selectMaintenanceMessageInfo = (state: any) => state.app.maintenanceMessageInfo
export const selectIsShowingFullPageError = (state: any) => state.app.isShowingFullPageError
export const selectFullPageError = (state: any) => state.app.fullPageError
export const selectIsShowingMobileConfigUpdate = (state: any) => state.app.isShowingMobileConfigUpdate
export const selectIsViewedMobileConfigUpdate = (state: any) => state.app.isViewedMobileConfigUpdate
export const selectMobileConfigUpdateReason = (state: any) => state.app.mobileConfigUpdateReason
export const selectNovelOrigin = (state: any) => state.app.novelOrigin
export const selectTempVideoPageHost = (state: any) => state.app.tempVideoPageHost
export const selectEnableHtmlUpdatedAlert = (state: any) => state.app.enableHtmlUpdatedAlert
export const selectEnableShare = (state: any): boolean => state.app.station.enable_share
export const selectIsNoticePopupDismissed = (state: any): boolean => state.app.isNoticePopupDismissed
export const selectIsIDCardPopupDismissed = (state: any): boolean => state.app.isIDCardPopupDismissed
export const selectMemberAnnounces = (state: any): SchemaMemberAnnounceShow[] | null => state.app.memberAnnounces
export const selectEnableNoticePopup = (state: any): boolean =>
  (state.app.memberAnnounces ?? []).some((item: SchemaMemberAnnounceShow) => item.id === NOTICE_POPUP_ID)
export const selectEnableIDCardPopup = (state: any): boolean =>
  (state.app.memberAnnounces ?? []).some((item: SchemaMemberAnnounceShow) => item.id === IDCARD_POPUP_ID)
export const selectIsMemberAnnounceLoaded = (state: any): boolean => state.app.memberAnnounces !== null
